export default __webpack_public_path__ + "static/media/2007.6ab3e199.png";